import type { CardMetadata } from '../types';
type NamedCard = CardMetadata & { name?: string; number?: string };
export function cardDisplayName(card?: NamedCard | null, locale = navigator.language): string {
  if (!card) return '';
  const preferred = locale.startsWith('zh') ? card.name_zh : locale.startsWith('ja') ? card.card_name : card.name_en;
  return preferred || card.card_name || card.name || '';
}
export function cardPrintedNumber(card?: NamedCard | null): string | undefined {
  if (!card) return undefined;
  // Old cached genuine printed numbers remain usable; product codes never become printed numbers.
  return card.printed_number || (card.printed_number === undefined && !card.number?.startsWith('pkmn-tcg-') ? card.number : undefined);
}
export function cardLanguageLabel(language: string): string {
  if (language === 'mul') return 'Multiple languages';
  try { return new Intl.DisplayNames([navigator.language], {type:'language'}).of(language === 'zh' ? 'zh-Hans' : language) || language; }
  catch { return language; }
}
